import { Component, OnInit, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { environment } from '@env/environment';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

@Component({
  standalone: true,
  imports: [CommonModule, RouterModule],
  selector: 'app-login',
  templateUrl: './login.component.html',
})
export class LoginComponent implements OnInit {
  errorMsg: string | null = null;

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private route: ActivatedRoute,
  ) {}

  ngOnInit(): void {
    // Only run in the browser
    if (!isPlatformBrowser(this.platformId)) {
      return;
    }
    // Check for error flag in query params
    this.route.queryParams.subscribe((params) => {
      if (params['error'] === 'invalid_token') {
        this.errorMsg = 'Token validation failed or expired.';
      } else {
        window.location.href = `${environment.apiUrl}/login`;
      }
    });
  }
}
